jQuery(document).ready(function () {
  let subscribeLink = jQuery('.diplayForm'),
    formationContent = jQuery('#ccecqa-formation'),
    form = jQuery('#ccecqa-formation__form'),
    formClose = jQuery('#closeForm');

  subscribeLink.on('click', function (event) {
    event.preventDefault();
    formationContent.addClass('hide');
    form.removeClass('hide');
    setTimeout(function () {
      jQuery('html,body').animate(
        {
          scrollTop: jQuery(form).offset().top - 200,
        },
        'slow'
      );
    }, 700);
  });

  formClose.on('click', function (event) {
    formationContent.removeClass('hide');
    form.addClass('hide');
  });
});
